import { render, staticRenderFns } from "./crmBind.vue?vue&type=template&id=45fb2548&scoped=true"
import script from "./crmBind.vue?vue&type=script&lang=js"
export * from "./crmBind.vue?vue&type=script&lang=js"
import style0 from "./crmBind.vue?vue&type=style&index=0&id=45fb2548&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb2548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45fb2548')) {
      api.createRecord('45fb2548', component.options)
    } else {
      api.reload('45fb2548', component.options)
    }
    module.hot.accept("./crmBind.vue?vue&type=template&id=45fb2548&scoped=true", function () {
      api.rerender('45fb2548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/other/crmBind.vue"
export default component.exports